import { queryOptions, useQuery } from '@tanstack/react-query';

import { teamApi } from '../api/team-api';

import { teamKeys } from './team-keys';

export function rolesQueryOptions() {
  return queryOptions({
    queryKey: teamKeys.roles(),
    queryFn: teamApi.listRoles,
    staleTime: 5 * 60_000,
  });
}

export function useRoles() {
  return useQuery(rolesQueryOptions());
}
